<template>
<div id="ContainerEmployeeCredential">
       <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
        {{$t('employeecredential.Edit')}}
      </h4>
      <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
        {{$t('employeecredential.Add')}}          
      </h4>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                     v-model="EmployeeCredential.code"                    
                     v-bind:Label="$t('Shared.Code')"          
                     v-bind:isReadOnly="this.$attrs.editMode"
                     v-bind:isRequired="true"
                     v-bind:MaxLengthProp="6"
                     v-bind:isValid="isEmployeeCredentialValid"
                     v-on:blur="OnCodeBlur(EmployeeCredential.code)"
                     :InvalidFeedback="$t('employeecredential.EmplCredCodeRequired')"
                     :SearchFieldCode="'Code'"
                     v-bind:Id="'input_e_cre'"
                  />
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                     v-model="EmployeeCredential.description"     
                     v-bind:MaxLengthProp="50"               
                     v-bind:Label="$t('Shared.Description')"  
                     v-bind:Id="'input_e_des'"
                  />
            </b-col> 
             
        </b-row>
       

    <div class="page-actions">      
     <MdButton
               v-bind:Label="$t('employeecredential.List')"
               v-bind:Name="'btnbtn_save_EmployeeCredentiallist'"
               v-bind:ClassProp="'secondary mx-2 btn-login'"
               v-on:click="DiscardChanges"/>    
        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="(this.isReadOnlyEmployeeCredential)?'primary mx-2':'primary btn-login mx-2'"
            v-on:click="SaveOrEdit"
            v-bind:isReadOnly="isReadOnlyEmployeeCredential"
            v-bind:Name="'btn_save_EmployeeCredential'"/>
    </div>

</div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import EmployeeCredentialService from '@/services/employeecredential.service'
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission'

//import Utils from '@/common/utils'

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
                this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Admission.Admission'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                    next();
                } else {
                    await this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },

  name: 'EmployeeCredential',
 mixins: [ShowMessage, DBFunctions, Permission/*,EventBus*/],
  data(){
    return{
        parameter:{
            SearchCriteria:'',
            PageNumber : 1,
            PageSize:0,         
        },
       EmployeeCredential:{
        code:"",
        description:""      
       },
       //Menu : this.$store.state.leftMenu,
       //permission:[],
       pendingChanges:false,
        isReadOnlyEmployeeCredential:false,
      isEmployeeCredentialValid:true,
      CodeExist:false,
        OptionsRightMenu:{
          visible:false,
          ItemsList:[],
          btnvisible:false,
          itemdisabled: false,
          PatientCode:'',
          Mode:this.edit_mode,
          favButtonAtion:false          
        },

    }
  },

  methods:{

    DiscardChanges(){
       this.checkExistFavorite('/app/employeecredentials');
       this.$router.push({name: "employeecredentialsList"});
    },

    AddEmployeeCredential(){
      if(!this.CodeExist){
      this.$emit('load', true);
      EmployeeCredentialService.Add(this.EmployeeCredential)
                .then((response) => {
                    if(response.status == '200'){
                        this.EmployeeCredential = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);
                        /*if(!this.OffRoute){
                           this.GotoAdmissionList();
                        }*/
                        this.$router.push({name: "employeecredentialsList"}).catch(()=>{});
                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })				
                .catch((error) => {   
                    /*if (!error.response) {
                   this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }                      
                     else if(error.response.status === 400 ){
                        this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }*/
                     elemSaveBtn.removeAttribute("disabled");  
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
      }else{
        this.showMessage(this.$tc('Msg.Error'),this.$t('employeecredential.EmplCredCodeExist'),"error");
      }
    },

     OnCodeBlur(value){           
          if(!this.$attrs.editMode){           
            if (value.trim()!== '') {          
            var parameter = {
               "code":value
            };
            EmployeeCredentialService.getEmployeeCredentialByCode(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                      // this.$emit('load', false);  
                       if(response.data.length > 0){
                          this.showMessage(this.$tc('Msg.Error'),this.$t('employeecredential.EmplCredCodeExist'),"error");
                          this.CodeExist = true;
                       }else{
                           this.CodeExist = false;
                       } 
                    }  
                     this.$emit('load', false);                          
                })
                .catch((error) => {
                    this.$emit('load', false);           
                    this.showResponseErrorMessage(error);       
                  /*if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }*/
                    
                });  
            }
               }
    
       },


    EditEmployeeCredential(){
      this.$emit('load', true);
     /* var data = {
        posName : this.PlaceOfService.posName
      }*/
      EmployeeCredentialService.Update(this.$route.params.id,this.EmployeeCredential)
                .then((response) => {
                    if(response.status == '200'){
                        this.EmployeeCredential = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);
                        /*if(!this.OffRoute){
                           this.GotoAdmissionList();
                        }*/
                        this.$router.push({name: "employeecredentialsList"}).catch(()=>{});
                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })
                .catch((error) => {   
                    /*if (!error.response) {
                   this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
                      }                      
                     else if(error.response.status === 400 ){
                        this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }*/
                     elemSaveBtn.removeAttribute("disabled");  
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
    },

  getEmployeeCredential(){
      if(this.$attrs.editMode){
      this.$emit('load', true);     
      EmployeeCredentialService.Get(this.$route.params.id)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.EmployeeCredential = response.data; 
             /* if(this.PlaceOfService){
                this.PlaceOfService.PosName = this.PlaceOfService.posName;
              }*/
            }   
              this.$emit('load', false);                     
        })
        .catch((error) => {                    
            /*if (!error.response) {
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToSave'),"error");
            }                      
            else if(error.response.status === 400 ){
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }
            else if(error.response.status === 405 ){             
                  this.$router.push({name: "Main"});    
                    setTimeout(() => 
                        this.showPermissionMessage()
                        , 50);            
            } 
            else if(error.response.status === 500){
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
            } else{
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            } */
            this.$emit('load', false);         
            this.showResponseErrorMessage(error);   
        }); 
    
      }
    },

      DoAction(){     
        !this.$attrs.editMode ? this.AddEmployeeCredential() : this.EditEmployeeCredential(); 
      },

      SaveOrEdit(){ 
         if (this.validate_required()) {
            this.DoAction();
         } else {
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
         }

      },

      validate_required() {
        this.isEmployeeCredentialValid = this.EmployeeCredential.code.length > 0 ? true : false;   
        return this.isEmployeeCredentialValid;
      },
      checkUserAction() {
        if (elemSaveBtn.disabled) {
          elemSaveBtn.removeAttribute('disabled');
        }
      },

        beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
  },

    created(){
        EventBus.$on("onChanged", function (e) {  
            this.pendingChanges = e.Changed;     
            this.checkUserAction();
        }.bind(this));
        //this.getPermissionLeftMenu(this.Menu,this.$route.path,this.permission);
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

  mounted(){
        this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
      this.getEmployeeCredential();
      setTimeout( function() {
         elemSaveBtn = document.getElementById('btn_save_EmployeeCredential');
         elemSaveBtn.setAttribute('disabled','');
      }, 50, this );  
  },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    },
   
};
</script>


